import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b074dfb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 2Dシミュレータに切り替えてよろしいですか？")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 表示に問題がある時はいつでも2Dモードに切り替えることができます ")
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 3Dシミュレータに切り替えてよろしいですか？")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 表示に問題がある時はいつでも2Dモードに切り替えることができます ")
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.isMobile ? 'hide-desktop' : 'hide-mobile'])
  }, [
    (_ctx.visible)
      ? _withDirectives((_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "modeButton",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
        }, [
          _createTextVNode(_toDisplayString(_ctx.isThreeMode ? '3D' : '2D'), 1)
        ])), [
          [_directive_tooltip, { content: '3Dと2Dモードを切り替えます', placement: 'right' }]
        ])
      : _createCommentVNode("", true),
    _createVNode(_component_ConfirmDialog, {
      onOnYes: _ctx.onYes,
      showEventName: _ctx.getShowEventName
    }, {
      default: _withCtx(() => [
        (_ctx.isThreeMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
          : _createCommentVNode("", true),
        (!_ctx.isThreeMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_10))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onOnYes", "showEventName"])
  ], 2))
}